import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme, styled } from '@mui/system';
import * as COLORS from '../styles/colors/colors';
import * as TYPOGRAPHY from '../styles/typography/typography';
import { PROMETHEAN_MEDIUM_SHADOW } from '../styles/elevation/elevation';
export var ROOT_PREFIX = 'EmbersModal';
export var TITLE_ROOT_PREFIX = 'EmbersModalTitle';
export var FOOTER_ROOT_PREFIX = 'EmbersModalFooter';
export var createDialogTheme = function createDialogTheme(theme) {
  var _root, _EmbersModalTitleRo2;
  return createTheme(_objectSpread(_objectSpread({}, theme || {}), {}, {
    components: {
      MuiDialog: {
        styleOverrides: {
          root: (_root = {}, _defineProperty(_root, ".".concat(ROOT_PREFIX, "-subtitle"), _objectSpread(_objectSpread({}, TYPOGRAPHY.PROMETHEAN_TYPOGRAPHY_SUBTITLE_01), {}, {
            margin: '0 0 16px 0'
          })), _defineProperty(_root, "&.".concat(ROOT_PREFIX, "-loading"), {
            '.MuiDialogContent-root': {
              display: 'flex',
              justifyContent: 'center'
            },
            '.MuiDialog-paperFullScreen': {
              '.MuiDialogContent-root': {
                alignItems: 'center',
                padding: '0 0 32px 0'
              }
            }
          }), _defineProperty(_root, "&.".concat(ROOT_PREFIX, "-feedback"), {
            '.MuiPaper-root': {
              ':not(.MuiDialog-paperFullScreen)': _defineProperty({
                '.MuiDialogContent-root': {
                  paddingTop: 32,
                  paddingRight: 76,
                  paddingBottom: 32,
                  paddingLeft: 68
                }
              }, "& .".concat(TITLE_ROOT_PREFIX, "-feedback"), {
                position: 'absolute',
                top: 6,
                right: 1
              })
            }
          }), _defineProperty(_root, "&.".concat(ROOT_PREFIX, "-announcement"), {
            '&> img': {
              width: '100%'
            },
            '.MuiDialogContent-root': {
              paddingTop: 20
            },
            '.MuiDialog-paperFullScreen': {
              '.MuiDialogContent-root': {
                paddingTop: 0
              },
              '.EmbersModal-subtitle': _objectSpread(_objectSpread({}, TYPOGRAPHY.PROMETHEAN_TYPOGRAPHY_H4), {}, {
                marginBottom: 0,
                minHeight: 32,
                display: 'flex',
                alignItems: 'center',
                padding: '29px 0 21px'
              })
            }
          }), _root),
          paper: _objectSpread(_objectSpread({
            minWidth: 686,
            borderRadius: 8,
            maxHeight: 'calc(100% - 104px)',
            marginTop: 24,
            marginBottom: 24
          }, PROMETHEAN_MEDIUM_SHADOW), {}, {
            /** borderRadius is ipad ios compatibility, overflow: hidden on the parent can't clip the top layer */
            '.EmbersModalTitle-root': _defineProperty({
              borderRadius: '8px 8px 0 0'
            }, "&.".concat(TITLE_ROOT_PREFIX, "-feedback"), _defineProperty({}, "&.".concat(TITLE_ROOT_PREFIX, "-hasCloseBtn"), {
              padding: 0
            })),
            '.EmbersModalFooter-root': {
              borderRadius: '0 0 8px 8px'
            }
          }),
          paperFullScreen: {
            minWidth: '100%',
            maxHeight: '100%',
            margin: 0,
            borderRadius: 0,
            background: COLORS.PROMETHEAN_NEUTRAL_WHITE,
            '.EmbersModalTitle-root': (_EmbersModalTitleRo2 = {
              paddingLeft: 24,
              paddingRight: 24
            }, _defineProperty(_EmbersModalTitleRo2, "&.".concat(TITLE_ROOT_PREFIX, "-hasCloseBtn"), _defineProperty({
              paddingRight: 57,
              paddingLeft: 24
            }, ".".concat(TITLE_ROOT_PREFIX, "-close"), {
              right: 16
            })), _defineProperty(_EmbersModalTitleRo2, "&.".concat(TITLE_ROOT_PREFIX, "-feedback-header"), _defineProperty({}, "&.".concat(TITLE_ROOT_PREFIX, "-hasCloseBtn"), {
              height: 82
            })), _EmbersModalTitleRo2),
            '.MuiDialogContent-root': {
              flex: 1,
              background: COLORS.PROMETHEAN_NEUTRAL_WHITE,
              padding: '0 24px 32px'
            },
            '.MuiDialogActions-root': {
              flexDirection: 'column',
              height: 'auto',
              padding: '16px 24px',
              flexFlow: 'column-reverse',
              paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
              '.EmbersLink': {
                margin: '8px 0'
              },
              '.EmbersModalFooter-buttons': {
                display: 'flex',
                flexDirection: 'column',
                flexFlow: 'column-reverse',
                width: '100%',
                '> button': {
                  margin: '8px 0'
                }
              }
            }
          }
        }
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            padding: '0px 32px 32px'
          }
        }
      }
    }
  }));
};
export var createDialogTitleTheme = function createDialogTitleTheme(theme) {
  var _objectSpread2;
  return createTheme(_objectSpread(_objectSpread({}, theme || {}), {}, {
    components: {
      MuiDialogTitle: {
        styleOverrides: {
          root: _objectSpread(_objectSpread({
            position: 'relative',
            display: 'flex',
            padding: 0,
            boxSizing: 'content-box',
            wordBreak: 'break-word',
            background: COLORS.PROMETHEAN_NEUTRAL_WHITE
          }, TYPOGRAPHY.PROMETHEAN_TYPOGRAPHY_H4), {}, (_objectSpread2 = {
            color: COLORS.PROMETHEAN_TEXT_HEADER
          }, _defineProperty(_objectSpread2, ".".concat(TITLE_ROOT_PREFIX, "-title"), {
            padding: '5px 0',
            margin: '24px 0 16px'
          }), _defineProperty(_objectSpread2, "&.".concat(TITLE_ROOT_PREFIX, "-destructive"), {
            color: COLORS.PROMETHEAN_ERROR_OR_DESTRUCT
          }), _defineProperty(_objectSpread2, "&.".concat(TITLE_ROOT_PREFIX, "-warning"), {
            color: COLORS.PROMETHEAN_PURPLE_PLUM
          }), _defineProperty(_objectSpread2, "&.".concat(TITLE_ROOT_PREFIX, "-error"), _defineProperty({}, ".".concat(TITLE_ROOT_PREFIX, "-icon"), {
            color: COLORS.PROMETHEAN_ALERT
          })), _defineProperty(_objectSpread2, ".".concat(TITLE_ROOT_PREFIX, "-icon"), {
            fontSize: 40,
            marginRight: 16,
            paddingTop: 26
          }), _objectSpread2))
        }
      }
    }
  }));
};
export var createDialogFooterTheme = function createDialogFooterTheme(theme) {
  var _root2;
  return createTheme(_objectSpread(_objectSpread({}, theme || {}), {}, {
    components: {
      MuiDialogActions: {
        styleOverrides: {
          root: (_root2 = {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            height: 88,
            padding: '0 32px',
            background: COLORS.PROMETHEAN_NEUTRAL_MID_GREY
          }, _defineProperty(_root2, ".".concat(FOOTER_ROOT_PREFIX, "-buttons"), {
            button: {
              marginLeft: 8
            }
          }), _defineProperty(_root2, "&.".concat(FOOTER_ROOT_PREFIX, "-tertiary-wrap"), {
            justifyContent: 'space-between'
          }), _root2)
        }
      }
    }
  }));
};
export var StyledModalHeader = styled('div')(function () {
  var _ref;
  return _ref = {
    padding: '0 32px'
  }, _defineProperty(_ref, "&.".concat(TITLE_ROOT_PREFIX, "-hasCloseBtn"), {
    paddingRight: 65
  }), _defineProperty(_ref, ".".concat(TITLE_ROOT_PREFIX, "-close"), {
    position: 'absolute',
    color: COLORS.PROMETHEAN_TEXT,
    right: 24,
    top: 24,
    width: 40,
    height: 40,
    '&.Mui-focusVisible': {
      border: '2px solid ' + COLORS.PROMETHEAN_BLUE,
      padding: 6,
      '.MuiTouchRipple-root': {
        backgroundColor: COLORS.PROMETHEAN_NEUTRAL_GREY_700,
        opacity: 0.2
      }
    }
  }), _defineProperty(_ref, "&.".concat(TITLE_ROOT_PREFIX, "-feedback-header"), _defineProperty({}, ".".concat(TITLE_ROOT_PREFIX, "-close"), {
    right: 20
  })), _ref;
});
export var StyledDisplayController = styled('div')(function (_ref2) {
  var show = _ref2.show;
  return {
    display: show === 'true' ? 'block' : 'none'
  };
});